import get from 'lodash.get';
import { Category } from '../models';
import { TrackingCategoryItem } from '~shared/modules/shopping-cart-global/models';

export function GetCategoryTreeArray(categoryTree: Category[]): TrackingCategoryItem[] {
  return categoryTree?.map(category => ({ id: category.id, name: category.name }));
}

export function GetCategoryTreeNamesArray(categoryTree) {
  return categoryTree?.map(category => get(category, 'name'));
}
